import { z } from 'zod'

/**
 * 「フック領域」（暫定テナント / hook/initialize）の Zod スキーマ。
 *
 * 関連: docs/system-requirements.md §4.1, §4.9
 */

// ----- POST /hook/initialize -----

export const HookInitializeInputSchema = z.object({
  visitorId: z.string().min(1).max(128),
  cookieId: z.string().uuid().optional(),
})
export type HookInitializeInput = z.infer<typeof HookInitializeInputSchema>

export const HookInitializeOutputSchema = z.object({
  ephemeralToken: z.string(),
  expiresAt: z.string().datetime(),
  tenantId: z.string().uuid(),
  cookieId: z.string().uuid(),
})
export type HookInitializeOutput = z.infer<typeof HookInitializeOutputSchema>
